import { render } from "./mainMenu.vue?vue&type=template&id=0c1e2309"
import script from "./mainMenu.vue?vue&type=script&lang=js"
export * from "./mainMenu.vue?vue&type=script&lang=js"

import "./mainMenu.vue?vue&type=style&index=0&id=0c1e2309&lang=less"

import exportComponent from "/var/jenkins_home/workspace/saas-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__